// extracted by mini-css-extract-plugin
module.exports = {"socialMediaBadges":"Footer_socialMediaBadges__RKkBk","footerBottom":"Footer_footerBottom__OFeMd","footerWave":"Footer_footerWave__odHIb"};